/**
 * @param {Object} state
 * @param {Object} payload
 */
const setDelivery = (state, payload) => {
  state.commit("SET_SELECTED_DELIVERY_INTERVENTION_PRODUCT_ID", payload.interventionProductId);
  state.commit("SET_SELECTED_DELIVERY_AGENCY_ID", payload.agencyId);
  state.commit("SET_SELECTED_DELIVERY_DATE_START", payload.start);
  state.commit("SET_SELECTED_DELIVERY_DATE_END", payload.end);
  state.commit("SET_SELECTED_DELIVERY_SELECTED_HOURS", payload.selectedHours);
  state.commit("SET_SELECTED_DELIVERY_SLOT_ID", payload.slotId);

  if(payload.fakeSlot !== undefined){
    state.commit("SET_SELECTED_DELIVERY_FAKE_SLOT", payload.fakeSlot);
  }
};

/**
 * @param {Object} state
 * @param {Object} payload
 */
const setDeliveryCart = (state, payload) => {
  state.commit("SET_SELECTED_DELIVERY_AGENCY_ID", payload.agencyId);
  state.commit("SET_SELECTED_DELIVERY_SELECTED_DATE", payload.selectedDate);
  state.commit("SET_SELECTED_DELIVERY_SLOT_ID", payload.slotId);
};

/**
 * @param {Object} state
 * @param {Object} payload
 */
const setSelectedDeliveryAgenciesData = (state, payload) => {
  state.commit("SET_SELECTED_DELIVERY_AGENCIES_DATA", payload);
};

/**
 * @param {Object} state
 * @param {Object} payload
 */
const setSelectedDeliveryCalendarData = (state, payload) => {
  state.commit("SET_SELECTED_DELIVERY_CALENDAR_DATA", payload);
};

/**
 * @param {Object} state
 * @param {Object} payload
 */
const setSelectedDeliveryCalendarDate = (state, payload) => {
  state.commit("SET_SELECTED_DELIVERY_CALENDAR_DATE_START", payload.start);
  state.commit("SET_SELECTED_DELIVERY_CALENDAR_DATE_END", payload.end);
};

/**
 * @param {Object} state
 * @param {String} id
 */
const setSelectedDeliveryId = (state, id) => {
  state.commit("SET_SELECTED_DELIVERY_ID", id);
};

/**
 * @param {Object} state
 * @param {String} id
 */
const setCurrentDeliveryId = (state, id) => {
  state.commit("SET_CURRENT_DELIVERY_ID", id);
};

/**
 * @param {Object} state
 */
const emptySelectedDelivery = state => {
  state.commit("EMPTY_SELECTED_DELIVERY");
};

/**
 * @param {Object} state
 * @param {String} payload
 */
const setSelectedDeliveryPostalCode = (state, postalCode) => {
  state.commit("SET_SELECTED_DELIVERY_POSTAL_CODE", postalCode);
};


const setDateUpdateSlotDelivery = (state, date) => {
  state.commit("SET_SELECT_SLOT_DATE", date)
}

const setDateFromServer = (state, date) => {
  state.commit("SET_SERVER_DATE_NOW", date)
}

const setDeliveryDateAvailability = (state, availability) => {
  state.commit("SET_DELIVERY_DATE_AVAILABILITY", availability)
}

export default {
  setDelivery,
  setDeliveryCart,
  setSelectedDeliveryId,
  setCurrentDeliveryId,
  emptySelectedDelivery,
  setSelectedDeliveryAgenciesData,
  setSelectedDeliveryCalendarData,
  setSelectedDeliveryCalendarDate,
  setSelectedDeliveryPostalCode,
  setDateUpdateSlotDelivery,
  setDateFromServer,
  setDeliveryDateAvailability
};
